import React from "react";
import { Link } from "react-router-dom";
import "./PoliticaPrivacidad.css";

const sections = [
  {
    title: "120 Padel",
    paragraphs: [
      '120 Padel (en lo sucesivo, "120 Padel") es responsable del tratamiento, uso y protección de los datos personales que recabe de sus usuarios a través de la aplicación móvil y de los servicios relacionados.',
      "Nos comprometemos a proteger su privacidad y a tratar sus datos personales conforme a la legislación aplicable en materia de protección de datos personales.",
    ],
  },
  {
    title: "Datos personales que recopilamos",
    paragraphs: [
      "Dependiendo del uso que haga de la aplicación, podremos solicitar o recopilar la siguiente información:",
    ],
    groups: [
      {
        title: "Datos de identificación",
        items: ["Nombre completo.", "Fecha de nacimiento (cuando sea requerida).", "Fotografía de perfil (opcional)."],
      },
      {
        title: "Datos de contacto",
        items: ["Correo electrónico.", "Número telefónico (cuando sea requerido)."],
      },
      {
        title: "Datos de cuenta",
        items: ["Usuario y contraseña (almacenada de forma segura y cifrada cuando corresponda)."],
      },
      {
        title: "Información de uso",
        items: [
          "Historial de reservas.",
          "Participación en partidos y torneos.",
          "Estadísticas deportivas.",
          "Preferencias dentro de la aplicación.",
        ],
      },
      {
        title: "Información técnica",
        items: [
          "Modelo del dispositivo.",
          "Sistema operativo.",
          "Dirección IP.",
          "Identificadores del dispositivo.",
          "Registros de funcionamiento de la aplicación para diagnóstico y mejora del servicio.",
        ],
      },
    ],
  },
  {
    title: "Datos de ubicación",
    paragraphs: [
      "En caso de ser necesario, podremos solicitar acceso a la ubicación del dispositivo únicamente para mejorar la experiencia del usuario, como mostrar clubes cercanos o servicios relacionados. El usuario podrá revocar este permiso en cualquier momento desde la configuración de su dispositivo.",
    ],
  },
  {
    title: "Finalidad del tratamiento de los datos",
    paragraphs: ["Los datos personales serán utilizados para:"],
    items: [
      "Crear y administrar su cuenta.",
      "Gestionar reservas de canchas.",
      "Organizar partidos y torneos.",
      "Administrar rankings y estadísticas.",
      "Brindar soporte técnico.",
      "Enviar notificaciones relacionadas con la operación de la aplicación.",
      "Mejorar continuamente nuestros servicios y funcionalidades.",
      "Cumplir con obligaciones legales.",
      "Enviar información promocional únicamente cuando el usuario haya otorgado su consentimiento.",
    ],
  },
  {
    title: "Pagos",
    paragraphs: [
      "En caso de realizar pagos dentro de la aplicación, estos podrán procesarse mediante plataformas especializadas de pago. 120 Padel no almacena la información completa de tarjetas bancarias; dicha información es administrada directamente por los proveedores de pago conforme a sus propias políticas de privacidad y estándares de seguridad.",
    ],
  },
  {
    title: "Protección de la información",
    paragraphs: [
      "Implementamos medidas administrativas, técnicas y físicas razonables para proteger los datos personales contra daño, pérdida, alteración, destrucción, acceso o tratamiento no autorizado.",
      "No obstante, ningún sistema de transmisión o almacenamiento electrónico puede garantizar una seguridad absoluta.",
    ],
  },
  {
    title: "Compartición de datos",
    paragraphs: [
      "120 Padel no vende ni comercializa los datos personales de sus usuarios.",
      "Los datos únicamente podrán ser compartidos cuando:",
    ],
    items: [
      "Sea necesario para la prestación del servicio mediante proveedores tecnológicos.",
      "Sea requerido por autoridades competentes conforme a la legislación aplicable.",
      "Exista autorización expresa del usuario.",
    ],
  },
  {
    title: "Derechos del usuario",
    paragraphs: [
      "El usuario podrá solicitar en cualquier momento el acceso, rectificación, actualización o eliminación de sus datos personales, así como revocar el consentimiento otorgado para su tratamiento, cuando la legislación aplicable así lo permita.",
      "Las solicitudes podrán realizarse a través del correo electrónico de contacto indicado al final de esta política.",
    ],
  },
  {
    title: "Conservación de la información",
    paragraphs: [
      "Los datos personales serán conservados únicamente durante el tiempo necesario para cumplir con las finalidades descritas en esta Política de Privacidad o mientras exista una relación activa con el usuario, salvo que la legislación aplicable establezca un plazo diferente.",
    ],
  },
  {
    title: "Menores de edad",
    paragraphs: [
      "La aplicación no está dirigida a menores de edad sin la autorización de sus padres o tutores. En caso de detectar información proporcionada por un menor sin autorización, ésta será eliminada tan pronto como sea posible.",
    ],
  },
  {
    title: "Cambios a esta Política",
    paragraphs: [
      "120 Padel podrá modificar la presente Política de Privacidad cuando resulte necesario por cambios legales, tecnológicos o en la operación de la aplicación.",
      "Las modificaciones serán publicadas dentro de la propia aplicación o por los medios oficiales disponibles.",
    ],
  },
  {
    title: "Contacto",
    paragraphs: [
      "Si tiene preguntas sobre esta Política de Privacidad o desea ejercer cualquiera de sus derechos relacionados con sus datos personales, puede comunicarse con nosotros mediante el correo electrónico de contacto de 120 Padel.",
    ],
  },
];

const BulletList = ({ items }) => {
  if (!items?.length) return null;
  return (
    <ul className="privacy-list">
      {items.map((item) => (
        <li key={item}>{item}</li>
      ))}
    </ul>
  );
};

const PoliticaPrivacidad = () => {
  return (
    <main className="privacy-page">
      <header className="privacy-header">
        <Link to="/" className="privacy-logo-link" aria-label="Ir al inicio">
          <img src={`${process.env.PUBLIC_URL}/assets/images/logo.png`} alt="120 Padel" />
        </Link>
      </header>

      <section className="privacy-hero">
        <div className="privacy-container">
          <p className="privacy-kicker">120 Padel</p>
          <h1>Política de Privacidad</h1>
          <p className="privacy-updated">Última actualización: 22 de julio de 2026</p>
        </div>
      </section>

      <section className="privacy-container privacy-card" aria-label="Contenido de política de privacidad">
        {sections.map((section) => (
          <article className="privacy-section" key={section.title}>
            <h2>{section.title}</h2>
            {section.paragraphs?.map((paragraph) => (
              <p key={paragraph}>{paragraph}</p>
            ))}
            {section.groups?.map((group) => (
              <div className="privacy-group" key={group.title}>
                <h3>{group.title}</h3>
                <BulletList items={group.items} />
              </div>
            ))}
            <BulletList items={section.items} />
          </article>
        ))}
      </section>
    </main>
  );
};

export default PoliticaPrivacidad;
